import React from "react";
import { Flex } from "theme-ui";
import { Icon } from "../../Utilities/Icons/Icon";
interface LoginProps {
  href: string;
  color?: string;
}

const LoginButton = ({ href, color = "black" }: LoginProps) => {
  return (
    <a
      href={href}
      sx={{
        display: "flex",
        justifyContent: "center",
        textDecoration: "none",
        "&:hover": {
          a: {
            color: "brand.accentBlue",
          },
          span: {
            color: "brand.accentBlue",
          },
          path: {
            stroke: "brand.accentBlue",
          },
        },
      }}
    >
      <Icon
        name={"lock-outlined"}
        alt={"Login"}
        color={color}
        size={25}
        sx={{
          mr: 1,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
        }}
      />
      <span
        sx={{
          fontWeight: "700",
          color: color,
        }}
      >
        Log In
      </span>
    </a>
  );
};

export default LoginButton;
